import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'

const descriptor = 'model::article'

export default pipe(
  modelComposition(descriptor),
)
